import React, { Component } from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import WeekPicker from 'components/common/WeekPicker'
import { setActiveDate } from 'reducers/seaLice/reducer'

class WeekFilter extends Component {
  onChangeWeek = date => {
    this.props.setActiveDate(
      moment.unix(date.lastDate).subtract(1, 'weeks').endOf('week'),
    )
  }

  render() {
    const { activeDate } = this.props

    const activeWeek = {
      firstDate: activeDate.startOf('isoWeek').unix(),
      lastDate: activeDate.endOf('isoWeek').unix(),
    }

    return <WeekPicker onChange={this.onChangeWeek} activeWeek={activeWeek} />
  }
}

export default connect(
  state => ({
    activeDate: state.getIn(['seaLice', 'activeDate']),
  }),
  {
    setActiveDate,
  },
)(WeekFilter)
